var CookieStorageAdapter = module.exports = function(options) {
    options = options || {}

    // Namespace fallback
    if (options.namespace) {
        this.prefix = options.namespace + '_'
    }

    // Persistence
    if (options.ttl) {
        this.ttl = options.ttl
    }

    // Security
    if (typeof options.secure !== 'undefined') {
        this.secure = options.secure
    }
}

CookieStorageAdapter.prototype = {

    /**
     * Cookie prefix
     */
    prefix: '',

    /**
     * Secure flag to prevent cookies being sent over plaintext
     */
    secure: true,

    /**
     * Cookie persistence interval (in days)
     */
    ttl: 365,

    /**
     * Saves a value to the store.  Persist will set a TTL of 2 months, otherwise storage will be session-based
     *
     * @param key
     * @param value
     * @param persist
     */
    setValue: function(key, value, persist, domain) {
        var date = new Date()

        // Advance by TTL
        date.setDate(date.getDate() + this.ttl)

        // Get the date string
        var expires = date.toUTCString()
        var expiresString = persist ? 'expires=' + expires + '; ' : ''

        // Domain setting
        var domainString = domain ? ('domain=' + domain + '; ') : ''

        // Set the cookie
        document.cookie = this.prefix + key + '=' + value + '; ' + expiresString + domainString + 'path=/' + (this.secure ? '; secure' : '')
    },

    /**
     * Gets a value from the store
     *
     * @param key
     */
    getValue: function(key) {
        var regex = new RegExp('(?:(?:^|.*;\\s*)' + this.prefix + key + '\\s*\\=\\s*([^;]*).*$)|^.*$')
        var value = document.cookie.replace(regex, '$1')
        return value || null
    },

    /**
     * Deletes a value from the store
     *
     * @param key
     */
    unsetValue: function(key, domain) {
        var domainString = domain ? ('domain=' + domain + '; ') : ''

        document.cookie = this.prefix + key + '=; ' + domainString + 'expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/' + (this.secure ? '; secure' : '')
    }
}
